import handleInit from './handleInit';
import handleItemsAppend from './handleItemsAppend';
import handleItemsReset from './handleItemsReset';

/**
 * Attach interactions to every element that matches selector.
 */
$('.masonry').each((_, component) => {
    // detach and cache item templates
    const $itemTemplates = $(component).find('[data-template]')
        .removeAttr('data-template')
        .detach();

    $(component).on('masonry:reset', handleItemsReset(component, $itemTemplates));
    $(component).on('masonry:append', handleItemsAppend(component, $itemTemplates));

    $(window).on('load', handleInit(component));
});



// WEBPACK FOOTER //
// ./src/scripts/components/masonry/index.js